import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

/**
 * Stamps `tenantId` on calls to our own API hosts. The anonymous tiers (/portal/*) have no token to
 * derive a tenant from; without the header the backend answers as its DEFAULT tenant.
 * Token XOR tenantId, never both: a bearer already carries the tenant and a second value breaks lookups.
 * A `tenantId` already set by the caller is left alone (the Snapcart form targets its own tenant).
 */
@Injectable()
export class TenantInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const env = environment as any;
        const ownHosts = [env.formsApiUrl, env.cmsApiUrl, env.apiUrl]
            .filter((h): h is string => typeof h === 'string' && h.length > 0);
        const isOurs = ownHosts.some(h => request.url.startsWith(h));
        if (!isOurs || !env.tenantId || request.headers.has('tenantId') || request.headers.has('Authorization')) {
            return next.handle(request);
        }
        return next.handle(request.clone({ setHeaders: { tenantId: env.tenantId } }));
    }
}
